import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ValidatedTextInput } from '../../../../../__legacy__/components/ValidatedTextInput';
import { MAX_FILE_NAME_LENGTH } from '../../../../../__legacy__/helpers/global.constants';
import { InputStatus } from '../../../../../__legacy__/models/error.model';
import { S_ConfirmationModal } from '../../../../../design/modals/confirmationModal/S_ConfirmationModal';

interface IProps {
  nameStatus: InputStatus;
  name: string;
  show: boolean;
  onSubmit: () => Promise<void>;
  onHide: () => void;
  onNameChange: (name: string) => void;
}

export const RenameAttachmentModal = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  const { show, onHide, onSubmit, name, nameStatus, onNameChange } = props;

  return (
    <S_ConfirmationModal
      submitText={t('attachments.modal.submit_text')}
      cancelText={t('attachments.modal.cancel_text')}
      toggle={onHide}
      onSubmit={onSubmit}
      onCancel={onHide}
      headerText={t('attachments.modal.header')}
      isOpen={show}
      disableSubmitButton={!nameStatus.isValid}
      loaderKey='rename-attachment-key'
    >
      <ValidatedTextInput
        onPressEnter={() => {
          void onSubmit();
        }}
        labelText={t('attachments.modal.label')}
        placeholder={t('attachments.modal.placeholder')}
        value={name}
        onChange={onNameChange}
        isValid={nameStatus.isValid}
        feedbacks={nameStatus.errorCodes}
        maxLength={MAX_FILE_NAME_LENGTH}
      />
    </S_ConfirmationModal>
  );
});
